import { Box, Container, Stack, Typography } from "@mui/material";
import PageNotFoundIcon from "assets/svg/PageNotFoundIcon";
import { Link } from "react-router-dom";
import theme, { responsiveFontSize } from "themes/Theme";

const NotFoundPage = () => {
  return (
    <Box>
      <Container sx={styles.container}>
        <Typography sx={styles.headingText}>Error 404</Typography>
        <Typography sx={styles.titleText}>Oops!</Typography>
        <Typography sx={styles.descText}>
          This is not the page your are looking for
        </Typography>
        <PageNotFoundIcon />
        <Typography sx={styles.linkHeadingText}>
          here is the some helpful link
        </Typography>
        <Stack direction={"row"} alignItems={"center"} gap={4}>
          <Link to={"/"} style={styles.linkText}>
            Home
          </Link>
          <Link to={"/about-us"} style={styles.linkText}>
            About
          </Link>
          <Link to={"/faq"} style={styles.linkText}>
            FAQs
          </Link>
          <Link to={"/contact-us"} style={styles.linkText}>
            Contact us
          </Link>
        </Stack>
      </Container>
    </Box>
  );
};
export default NotFoundPage;
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  },
  headingText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.text.primary,
    fontWeight: 400,
  },
  titleText: {
    fontSize: responsiveFontSize(48),
    color: theme.palette.custom.red || "#c82424",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  descText: {
    fontSize: responsiveFontSize(16),
    color: theme.palette.text.primary,
    fontWeight: 400,
    marginTop: "15px",
  },
  linkHeadingText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.text.secondary,
    fontWeight: 400,
    marginTop: "6em",
  },
  linkText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.primary.main,
    marginTop: "10px",
  },
};
